<template>
  <div class="consumRecords">
    <el-scrollbar style="height: 100%" v-if="orders.length > 0">
      <el-timeline>
        <el-timeline-item
          v-for="(order, index) in orders"
          :key="index"
          icon="el-icon-time"
          type="primary"
          size="large"
          placement="top"
          :timestamp="order.createTime"
        >
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ order.typeName }}</span>
              <el-button
                style="float: right; padding: 3px"
                icon="el-icon-delete"
                circle
                @click="delteRecord(order.id)"
              ></el-button>
            </div>
            <!-- <p>产品: </p> -->
            <p v-if="order.childTypeName">周期: {{ order.childTypeName }}</p>
            <p>金额: {{ order.price }} 元</p>
            <p>
              <span class="remark">备注: {{ order.remark }}</span>
            </p>
            <p>
              <el-button
                size="mini"
                type="primary"
                plain
                round
                v-if="order.voucherId"
                @click="show(order.voucherId)"
                >验光单</el-button
              >
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </el-scrollbar>
    <div style="height: 100%; text-align: center; line-height: 200px" v-else>
      <span style="color: dimgrey">暂无配镜信息</span>
    </div>

    <div v-if="voucherDialog.show">
      <el-dialog
        width="780px"
        :visible.sync="voucherDialog.show"
        :close-on-click-modal="voucherDialog.clickModal"
        :close-on-press-escape="voucherDialog.pressEscape"
        append-to-body
      >
        <eye-voucher
          operation="show"
          :voucherId="voucherDialog.voucherId"
        ></eye-voucher>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { getOrderAll, delOrder } from "@/api/index";
import EyeVoucher from "./EyeVoucher.vue";

export default {
  name: "consumRecords",
  props: {
    member: Object,
  },
  components: {
    EyeVoucher,
  },
  data() {
    return {
      orders: [],
      voucherDialog: {
        show: false,
        clickModal: false,
        pressEscape: true,
        voucherId: null,
      },
    };
  },
  methods: {
    show(voucherId) {
      this.voucherDialog.voucherId = voucherId;
      this.voucherDialog.show = true;
    },
    getOrderPage() {
      getOrderAll({
        memberId: this.member.id,
      }).then((res) => {
        if (res.success == true) {
          this.orders = res.result;
        } else {
          this.$notify.error({
            title: "错误",
            message: res.message,
          });
        }
      });
    },
    delteRecord(id) {
      this.$confirm("你确定要删除该订单吗？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      })
        .then(() => {
          delOrder(id).then((res) => {
            if (res.success == true) {
              this.$message({
                type: "info",
                message: "删除成功",
              });
              this.getOrderPage();
            } else {
              this.$notify.error({
                title: "错误",
                message: res.message,
              });
            }
          });
        })
        .catch((action) => {
          
        });
    },
  },
  mounted() {
    this.getOrderPage();
  },
};
</script>
<style lang="scss">
.consumRecords {
  margin-left: 10px;
  height: 350px;

  .el-scrollbar__wrap {
    overflow-x: hidden;
  }
  .el-timeline-item__node--large {
    left: 1px;
  }
  .el-timeline-item__tail {
    left: 7px;
  }

  .box-card {
    width: 70%;

    p {
      margin-bottom: 10px;
    }

    .remark {
      font-size: 13px;
      color: dimgrey;
    }
  }

  .el-dialog {
    widows: 880px;
  }
}
.el-dialog__body {
  padding: 0px;
}
</style>